module.exports = __webpack_public_path__ + "static/media/company5Text.dbbda9c7.png";